// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0u4yI","logo":"Footer_logo__VPjYq"};